import { render, staticRenderFns } from "./GsAccordion.vue?vue&type=template&id=ab403b3a&scoped=true"
import script from "./GsAccordion.vue?vue&type=script&lang=js"
export * from "./GsAccordion.vue?vue&type=script&lang=js"
import style0 from "./GsAccordion.vue?vue&type=style&index=0&id=ab403b3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab403b3a",
  null
  
)

export default component.exports